export enum AuditAction {
  LOGIN = 'LOGIN',
  USER_INVITED = 'USER_INVITED',
  CONTENT_CREATED = 'CONTENT_CREATED',
  CONTENT_EDITED = 'CONTENT_EDITED',
  CONTENT_PUBLISHED = 'CONTENT_PUBLISHED',
  CONTENT_UNPUBLISHED = 'CONTENT_UNPUBLISHED',
}

/** Mirrors AuditLogResponse from GET /api/audit-log in the UAM CMS backend. */
export interface AuditLogEntry {
  id: string;
  actorId: string;
  action: AuditAction;
  itemId?: string;
  occurredAt: string;
}
